import { render, staticRenderFns } from "./visitor-archive-restore.vue?vue&type=template&id=721362e8&scoped=true"
import script from "./visitor-archive-restore.vue?vue&type=script&lang=js"
export * from "./visitor-archive-restore.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "721362e8",
  null
  
)

export default component.exports